import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonItalic: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      isItalic: ctx.editor?.isActive("italic") || false,
      canItalic: ctx.editor?.can().chain().toggleItalic().run() ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().toggleItalic().run()}
      disabled={!editorState.canItalic}
      active={editorState.isItalic}
      icon="format_italic"
      tooltip="Italic"
    />
  );
};
